import { render } from "./BranchDashboard.vue?vue&type=template&id=f9d30a88"
import script from "./BranchDashboard.vue?vue&type=script&lang=js"
export * from "./BranchDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script